import classNames from "classnames";
import React from "react";
import { AppButton } from "../AppButton";
import styles from "./styles.module.css";

interface Props {
  className?: string;
  leftContent?: string | React.ReactNode;
  buttonTitle?: boolean;
  buttonClassName?: string;
  children?: React.ReactNode;
  disabled?: boolean;
  leftContentSize?: "min" | "max";
  leftContentClass?: string;
  rightContentClass?: string;
  onClick?: () => void;
}

export const AppUnderlinedTitle: React.FC<Props> = ({
  className,
  leftContent,
  buttonTitle,
  buttonClassName,
  children,
  leftContentSize = "min",
  leftContentClass,
  rightContentClass,
  disabled,
  onClick,
}) => {
  return (
    <div className={classNames(styles.title, className)}>
      {buttonTitle ? (
        <AppButton
          className={buttonClassName}
          onClick={onClick}
          buttonType="text"
          disabled={disabled}
        >
          {leftContent}
        </AppButton>
      ) : (
        <div
          className={classNames(
            leftContentSize === "min"
              ? styles["left-content-min"]
              : styles["left-content-max"],
            leftContentClass
          )}
        >
          {leftContent || ""}
        </div>
      )}
      <div className={classNames(styles.absolute, rightContentClass)}>
        {children}
      </div>
    </div>
  );
};
